import clsx from 'clsx'
import {FormikValues} from 'formik'
import {useCallback, useEffect, useRef} from 'react'
import Flatpickr from 'react-flatpickr'

type Props = {
  formik: FormikValues
  fieldName: string
  placeholder?: string
  container?: string
  dateformat?: string
}

export const formatDateTo12Hour = (date: Date): string => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  const hours = date.getHours()
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  const ampm = hours >= 12 ? 'PM' : 'AM'
  const hour12 = hours % 12 === 0 ? 12 : hours % 12 // 0 or 12 → 12

  return `${year}-${month}-${day} ${String(hour12).padStart(2, '0')}:${minutes}:${seconds} ${ampm}`
}

const FlatPickrDateTime = ({
  formik,
  fieldName,
  placeholder = 'Pick a Date',
  container,
  dateformat = 'Y-m-d H:i:S',
}: Props) => {
  const handleReady = (
    selectedDates: Date[],
    dateStr: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    instance: any
  ) => {
    const calendar = instance.calendarContainer

    // Modify inline styles
    if (calendar) {
      calendar.style.top = '40px'
      calendar.style.left = '0px'
      calendar.style.width = '100%'
      calendar.style.display = 'inline'
    }
  }

  const flatpickrRef = useRef<Flatpickr>(null)

  const destroyFlatpickr = useCallback(() => {
    try {
      if (flatpickrRef.current?.flatpickr?.destroy) {
        flatpickrRef.current.flatpickr.destroy()
      }
    } catch (error) {
      console.warn('Flatpickr destruction error', error)
    }
  }, [])

  // useEffect(() => {
  //   return () => destroyFlatpickr()
  // }, [destroyFlatpickr])

  return (
    <Flatpickr
      ref={flatpickrRef}
      onReady={handleReady}
      value={formik.values[fieldName] ? new Date(formik.values[fieldName]) : undefined}
      onChange={([date]) => {
        // const formattedDate = date ? date.toISOString().split("T")[0] : "";
        // const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        //   2,
        //   '0'
        // )}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(
        //   2,
        //   '0'
        // )}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(
        //   2,
        //   '0'
        // )}`

        if (!date) return

        const formattedDate = formatDateTo12Hour(date)

        // console.log(formattedDate)
        // console.log(date)
        formik.setFieldValue(fieldName, formattedDate)
      }}
      className='form-control form-control custom-input mb-3 mb-lg-0 w-100'
      options={{
        static: true,
        enableTime: true,
        dateFormat: dateformat,
        clickOpens: true, // Only open on click
        appendTo: (container && document.getElementById(container)) || undefined,
        time_24hr: false,
      }}
      placeholder={placeholder}
    />
  )
}

export default FlatPickrDateTime
